import ConfigService from './services/config/config.service';
import { IsProduction } from "./util/Environment";

function sleep(seconds: number): Promise<void> {
    return new Promise(res => setTimeout(res, seconds * 1000));
}

export async function LoadStaticScripts(history: any) {
    await sleep(4);

    if (IsProduction()) {
        // Migrado de `react-ga` (GA Universal Analytics, descontinuado pelo Google em 2023)
        // para `react-ga4` (GA4). API equivalente: `pageview()` foi substituido por
        // `send({ hitType: "pageview", page })`.
        const ReactGA = (await import("react-ga4")).default;
        const Hotjar = (await import("react-hotjar")).hotjar;

        const config = ConfigService.getConfig().miscellaneousConfig;

        ReactGA.initialize(config.gATracking);
        Hotjar.initialize({
            id: Number(config.hotjarId),
            sv: Number(config.hotjarSV)
        });

        history.listen((location, action) => {
            ReactGA.set({ page: location.pathname });
            ReactGA.send({ hitType: "pageview", page: location.pathname });
            window.scrollTo(0, 0);
        });
    }
}
